<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/Program/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>